// ===== CỜ BẬT / TẮT TÍNH NĂNG (cố định theo bản build) =====
// Gom 1 chỗ để bật/tắt nhanh, không phải đi tìm từng file. Đổi true/false rồi build lại.
// Cờ cần đổi KHÔNG build lại (theo tenant / theo người dùng) thì dùng Quản trị → OMConfig như cũ.
// File thuần (không import gì) để util có test vẫn import được bằng đường dẫn tương đối.
// Thêm cờ mới: ghi rõ tính năng, file dùng, ngày + người bật/tắt.

// --- ĐƠN HÀNG ---

// Tạo/cập nhật đơn cơ bản (1/2/6/10): mỗi lần chọn SP là 1 dòng riêng (cùng mã có thể nhiều giá).
// false = bản cũ, gộp theo mã. Dùng: CreateOrders/store.ts → hook/deviceLines.ts (tachDong)
export const TACH_DONG_SP = false;

// Đơn ĐL lắp giùm (9): danh sách SP dựng từ chi tiết xe, mỗi chi tiết 1 dòng để nhập giá riêng từng xe.
// false = bản cũ, cộng dồn theo mã. Dùng: hook/deviceLines.ts (linesFromDetails) → createOrders, UpdateOrders
export const TACH_DONG_SP_DLL = false;

// Nút "Trả hàng" ở đơn loại 1-10 đã hoàn tất (modal ReturnStockModal → api/ReturnProduct/CreateV2).
// false = ẩn nút và không gọi GetByOrder. Dùng: CreateOrders/common/UpdateOrders.tsx (canReturnStock)
export const NUT_TRA_HANG = true;

// Đơn thu nợ (type 11) bản mới: cột trái nhập thêm, tick theo cột, gán tiền dư vào đơn, bảng đơn nợ tách phụ thu,
// tiền âm → 0. false = bản cũ. Dùng: thuNoAllocation.ts (re-export) → createOrders, UpdateOrders, PaymentOrderTemp,
// OrderDetailThuNo, XuLyDonNo
export const THU_NO_NHAP_THEM = false;

// --- KHO: CẤP PHÁT SẢN PHẨM (Kho kỹ thuật → tab Cấp phát sản phẩm) ---

// Cột "Sản phẩm đã chọn" 280px bên phải bảng (tìm, bỏ chọn từng SP, nút "Cấp phát N sản phẩm").
// false = giao diện cũ: chỉ có bảng, cấp phát bằng nút "Tạo lệnh". Dùng: StockTechnician/Technician/StockTechnician.tsx
export const CAP_PHAT_COT_DA_CHON = true;

// Modal cấp phát hàng loạt: nút "+ Thêm sản phẩm" (chọn nhiều SP, thêm vào đúng nhóm kỹ thuật).
// false = giao diện cũ: không có nút, modal trống chỉ hiện dòng hướng dẫn; tab Kho kỹ thuật cũng không tải sẵn
// danh sách 1000 SP. Dùng: ModalTechnician/BulkAssignModal.tsx, Technician/TabsStock.tsx
export const CAP_PHAT_THEM_SP = true;

// --- KHO: TRẢ HÀNG (Import file trả hàng) ---

// File trả hàng mới: bỏ cột Đơn giá / Thành tiền / Mã KH, thêm SĐT KH; gửi thêm distributorName, customerPhoneNum,
// customerName (server tự lấy mã KH + tên KH từ SĐT); dòng có SĐT là đủ thông tin khách; ô PN chỉ ghi STT phiếu,
// web ghép thành <chi nhánh><yymm><PN> (vd SG2610102). false = bản cũ: file mẫu cũ, PN giữ nguyên, bắt buộc Mã KH
// hoặc Mã đơn, không gửi 3 trường mới (dùng khi server chưa cập nhật).
// Dùng: StockManagment/ReturnProduct/Modify/ImportFileModal.tsx
export const TRA_HANG_IMPORT_SDT = true;

// --- HỖ TRỢ CSKH ---

// Bộ lọc nhanh Công ty / Nhóm (CskhQuickFilter) trên thanh header app, trang Quản lý phiếu.
// Đang tắt vì bộ lọc đã nằm trong thanh lọc tab Danh sách (cờ bên dưới). Dùng: components/ui/Header.tsx
export const CSKH_FILTER_HEADER = false;

// Bộ lọc Công ty / Nhóm (CskhQuickFilter) trong thanh lọc tab Danh sách của Quản lý phiếu, giống tab Lịch sử.
// Hiện cho mọi vai trò; chỉ CSKH mới tự lưu cấu hình phụ trách (StaffAssignTag) khi đổi, như bản trên header.
// Dùng: pages/CSKHManagment/TickerManager/TicketManager.tsx
export const CSKH_FILTER_IN_LIST = true;

// --- BÁO CÁO ---

// BC doanh thu KH (/bao-cao-doanh-thu-khach-hang): ô "KD quản lý" có dòng "Tất cả" (gửi saleAccount = '').
// Hiện cho Root/Admin/BranchManager và kế toán có trong OMConfig TIEN_CSKH (state.user.tienCSKH); kế toán khác không thấy.
// Đang chọn "Tất cả" thì không cho chốt tháng. Dùng: pages/Report/ReportDoanhThuV2 (ReportHeader, ReportDoanhThuV3)
export const BC_DOANH_THU_KH_TAT_CA = true;
